module.exports = __webpack_public_path__ + "static/media/challah.c8beb9f9.JPG";